import { useEffect, useRef, useState } from 'react';

/**
 * Bouton microphone qui dicte dans un champ texte via Web Speech API (SpeechRecognition).
 * Ajoute le texte dicté à la valeur actuelle. Arrête à la première pause significative.
 */
export default function DictateButton({
  value,
  onChange,
  lang = 'fr-FR',
  title = 'Dicter',
}: {
  value: string;
  onChange: (next: string) => void;
  lang?: string;
  title?: string;
}) {
  const [listening, setListening] = useState(false);
  const [supported, setSupported] = useState(true);
  const recogRef = useRef<any>(null);

  useEffect(() => {
    const W = window as unknown as {
      SpeechRecognition?: any;
      webkitSpeechRecognition?: any;
    };
    const SR = W.SpeechRecognition ?? W.webkitSpeechRecognition;
    setSupported(!!SR);
  }, []);

  function toggle() {
    const W = window as unknown as {
      SpeechRecognition?: any;
      webkitSpeechRecognition?: any;
    };
    const SR = W.SpeechRecognition ?? W.webkitSpeechRecognition;
    if (!SR) return;
    if (listening) {
      recogRef.current?.stop();
      return;
    }
    const r = new SR();
    r.lang = lang;
    r.interimResults = true;
    r.continuous = false;
    let finalAppended = '';
    r.onresult = (ev: any) => {
      let interim = '';
      let finalPart = '';
      for (let i = ev.resultIndex; i < ev.results.length; i++) {
        const tr = ev.results[i][0].transcript;
        if (ev.results[i].isFinal) finalPart += tr;
        else interim += tr;
      }
      if (finalPart) {
        finalAppended += finalPart;
        const suffix = finalAppended.startsWith(' ') ? finalAppended : ` ${finalAppended}`;
        onChange(`${value}${suffix}`);
      } else if (interim) {
        // Ne modifie pas la value pendant l'interim (éviterait d'écraser l'utilisateur)
      }
    };
    r.onerror = () => setListening(false);
    r.onend = () => setListening(false);
    recogRef.current = r;
    r.start();
    setListening(true);
  }

  if (!supported) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      title={title + (listening ? ' (en cours)' : '')}
      className={`dictate-btn ${listening ? 'active' : ''}`}
    >
      {listening ? '🔴' : '🎙'}
    </button>
  );
}
